import React from "react";
import { node } from "prop-types";
import { Col, Container, Row } from "../Grid";

const HeaderContainer = ({ children }) => (
	<Container>
		<Row px className="header__layout navbar">
			<Col>
				<Row middle>{children}</Row>
			</Col>
		</Row>
	</Container>
);

HeaderContainer.propTypes = {
	children: node.isRequired,
};

export default HeaderContainer;
